<template>
  <div
    v-if="content"
    :class="{
      'absolute bottom-1.5 right-1.5': true,
    }"
  >
    <div
      :class="{
        'group grid size-3.5 place-content-center rounded-full border text-xs text-www-color-neutral-medium-light': true,
      }"
    >
      &quest;
      <p
        :class="{
          'absolute start-7 top-1/2 z-10 hidden w-320px -translate-y-1/2 rounded-sm bg-www-color-neutral-dark px-6 py-4 text-center font-medium text-www-color-white group-hover:flex': true,
          'before:absolute before:right-full before:top-1/2 before:-translate-y-1/2 before:border-[5px] before:border-www-color-transparent before:border-r-www-color-neutral-dark before:content-[\'\']': true,
        }"
      >
        {{ content }}
      </p>
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  content?: string;
}

defineProps<Props>();
</script>
